import React from 'react';
import { Link } from 'react-router-dom';

export default () => {
    return (
        <footer>
            &copy; METAR Reader 2011 - { new Date().getFullYear() } | <Link to={`/stations`} title="Stations">Stations</Link>
        </footer>
    )
}